<div
    class="container-fluid contract-list"
    [ngClass]="{ 'no-footer-mobile': !hasManagedContracts, 'has-app-banner': showAppBanner && !cameFromNewLocal }"
>
    <div class="flex-grow-0">
        <div class="d-flex flex-row justify-content-between">
            <a
                class="btn-back d-flex justify-content-end mt-3 mr-2 mt-md-4 mr-lg-3"
                *ngIf="!!cameFromNewLocal"
                (click)="openNewLocalModal()"
            >
                <i class="icon-edponline-Bop-078 rotate-180" aria-hidden="true"></i>
            </a>

            <a
                class="btn-close d-flex justify-content-end mt-2 mr-2 mt-md-4 mr-lg-3"
                *ngIf="data.showClose && !cameFromNewLocal"
                data-modal="dismiss()"
                (click)="dismiss()"
            >
                <i class="icon-edponline-Bop-071 color-brownish-grey" aria-hidden="true"></i>
            </a>
        </div>

        <div
            class="d-flex flex-row justify-content-between contract-list-header align-items-start"
            [ngClass]="{ 'mt-5 mt-md-0': data.showClose && !cameFromNewLocal, 'mt-4 mt-md-0': !!cameFromNewLocal }"
        >
            <ng-container *ngIf="!cameFromNewLocal">
                <div class="d-flex flex-column">
                    <span *ngIf="!isSearching">
                        {{ "pt.edp.edponline.contract.list.consumption.local.select" | translate }}
                        <span class="contract-title">
                            {{ "pt.edp.edponline.contract.consumption.local" | translate | lowercase }}
                        </span>
                        {{ "pt.edp.edponline.contract.list.consumption.local.wanted" | translate }}
                    </span>
                </div>
            </ng-container>
            <span *ngIf="!isSearching && !!cameFromNewLocal">
                {{ "pt.edp.edponline.contract.list.consumption.local_plural" | translate }}
            </span>
        </div>

        <ng-container *ngIf="isSearchable">
            <div>
                <ng-container *ngTemplateOutlet="searchDefault"></ng-container>
            </div>
        </ng-container>

        <div class="d-flex flex-row justify-content-between align-items-center">
            <span class="contract-list-subheader mb-3" [ngClass]="{ 'subheader-filters': isSearchable }">
                <span class="contract-title">{{ tempContracts ? tempContracts.length : 0 }}</span>
                {{ "pt.edp.edponline.contract.list.consumption.local_plural" | translate }}
            </span>
        </div>
    </div>

    <div class="row row-cols-md-2 row-cols-lg-3 row-cols-xxl-5 edp-scroll-disabled contract-list-body">
        <ng-container *ngIf="tempContracts?.length && tempContracts?.length > 0; else templateSyncWallet">
            <ng-container *ngFor="let contract of tempContracts">
                <edp-contract-local-card
                    class="col mb-2 mb-md-4 d-block"
                    [contract]="contract"
                    [selected]="selectedContract"
                    [biggerCard]="true"
                    (selectedContract)="selectContract($event)"
                ></edp-contract-local-card>
            </ng-container>
            <ng-container *ngFor="let pendingContract of pendingContracts">
                <edp-card-pending-approval
                    [pendingContract]="pendingContract"
                    (removeHandle)="openRemoveContractModal(pendingContract)"
                    class="col mb-4 d-block padding-02"
                ></edp-card-pending-approval>
            </ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="templateAddContract"></ng-container>
    </div>
</div>

<div class="contract-list-footer d-lg-block" [ngClass]="{ 'd-none': !hasManagedContracts && !hasPendingContractsWithToken }">
    <div class="container-fluid h-100 p-0">
        <div class="row h-100 footer-row">
            <div
                class="footer-left-column d-flex align-items-center justify-content-center "
                *ngIf="hasManagedContracts || hasPendingContractsWithToken"
            >
                <div *ngIf="isCollapsed" class="edit-access-closed">
                    <a (click)="toggleEditAccess()" [ngClass]="{ 'light-font': !!cameFromNewLocal }">
                        <span class="d-inline-block align-middle">
                            {{
                                (!cameFromNewLocal
                                    ? "pt.edp.edponline.contract.list.consumption.local.edit"
                                    : "pt.edp.edponline.contract.consumption.local.manage.locals"
                                )
                                    | translate
                                    | edpCapitalize
                            }}
                            <span class="d-inline-block align-middle ml-2"><i class="icon-edponline-Bop-022" aria-hidden="true"></i></span>
                        </span>
                    </a>
                </div>
                <div [ngbCollapse]="isCollapsed" class="edit-access">
                    <div class="d-block d-lg-none p-3 header-mobile">
                        <a class="button" (click)="toggleEditAccess()" [ngClass]="{ 'light-font': !!cameFromNewLocal }">
                            <span><i class="icon-edponline-Bop-078 rotate-180 icon-2x" aria-hidden="true"></i></span>
                        </a>
                    </div>
                    <ul
                        ngbNav
                        #nav="ngbNav"
                        [(activeId)]="activeTab"
                        class="nav-tabs nav-fill position-relative"
                        (navChange)="navChanged($event)"
                    >
                        <li [ngbNavItem]="1" ngbNavItem [ngClass]="{ active: activeTab === 1 }" *ngIf="contractsManagedByOthers.length > 0">
                            <a ngbNavLink>{{ "pt.edp.edponline.your.places" | translate }}</a>
                            <ng-template ngbNavContent>
                                <div class="edit-access-content pt-5 px-5">
                                    <p>{{ "pt.edp.edponline.remove.access.from.who" | translate }}</p>
                                    <label>{{ "pt.edp.edponline.select.user" | translate }}</label>
                                    <edp-select-list
                                        [halfHeight]="true"
                                        [options]="contractsManagedByOthers"
                                        (nextOptions)="onSelectListChange($event)"
                                    ></edp-select-list>
                                    <p class="smaller-info" *ngIf="showMultipleContractsWarning">
                                        {{
                                            "pt.edp.edponline.selected.user.warning"
                                                | translate: { contractManagerName: multipleContractsName }
                                        }}
                                    </p>
                                </div>
                                <div class="d-flex footer-mobile">
                                    <a (click)="removeAccess(false)" [ngClass]="{ 'link-disabled': disableRemoveButton }">
                                        <span>{{ "pt.edp.edponline.remove.access" | translate }}</span>
                                    </a>
                                </div>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2" ngbNavItem [ngClass]="{ active: activeTab === 2 }" *ngIf="contractsManagedByMe.length > 0">
                            <a ngbNavLink>{{ "pt.edp.edponline.thirdparty.places" | translate }}</a>
                            <ng-template ngbNavContent>
                                <div class="edit-access-content pt-5 px-5">
                                    <p>{{ "pt.edp.edponline.remove.access.from.which.holder" | translate }}</p>
                                    <label>{{ "pt.edp.edponline.select.holder" | translate }}</label>
                                    <edp-select-list
                                        [halfHeight]="true"
                                        [options]="contractsManagedByMe"
                                        (nextOptions)="onSelectListChange($event)"
                                    ></edp-select-list>
                                    <p class="smaller-info" *ngIf="showMultipleContractsWarning">
                                        {{
                                            "pt.edp.edponline.selected.holder.warning"
                                                | translate: { contractOwnerName: multipleContractsName }
                                        }}
                                    </p>
                                </div>
                                <div class="d-flex footer-mobile">
                                    <a (click)="removeAccess(true)" [ngClass]="{ 'link-disabled': disableRemoveButton }">
                                        <span>{{ "pt.edp.edponline.remove.place" | translate }}</span>
                                    </a>
                                </div>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="3" ngbNavItem [ngClass]="{ active: activeTab === 3 }" *ngIf="hasPendingContractsWithToken">
                            <a ngbNavLink>{{ "pt.edp.edponline.thirdparty.accesscode.tab" | translate }}</a>
                            <ng-template ngbNavContent>
                                <div class="edit-access-content pt-5 px-5">
                                    <label>{{ "pt.edp.edponline.thirdparty.accesscode.select.holder" | translate }}</label>
                                    <edp-select-list
                                        [halfHeight]="true"
                                        [options]="contractsPendingList"
                                        (nextOptions)="onSelectListChange($event)"
                                    ></edp-select-list>
                                </div>
                                <div class="edit-access-content px-5">
                                    <label>{{ "pt.edp.edponline.thirdparty.accesscode.label" | translate }}</label>
                                    <input
                                        type="text"
                                        class="w-100"
                                        placeholder="{{ 'pt.edp.edponline.thirdparty.accesscode.placeholder' | translate }}"
                                        [(ngModel)]="accessCode"
                                    />
                                </div>
                                <div class="d-flex footer-mobile">
                                    <a
                                        (click)="validateContract()"
                                        [ngClass]="{ 'link-disabled': !accessCode?.length || !selectListItemSelected }"
                                    >
                                        <span>{{ "pt.edp.edponline.thirdparty.accesscode.validate" | translate }}</span>
                                    </a>
                                </div>
                            </ng-template>
                        </li>
                        <a
                            class="button d-none d-lg-block close"
                            (click)="toggleEditAccess()"
                            [ngClass]="{ paintWhite: activeTab === 1 && contractsManagedByMe.length > 0 }"
                        >
                            <span><i class="icon-edponline-Bop-071" aria-hidden="true"></i></span>
                        </a>
                    </ul>
                    <div [ngbNavOutlet]="nav"></div>
                </div>
            </div>
            <div
                class="d-none d-lg-block footer-right-column"
                [ngClass]="{ 'footer-right-column-full': !hasManagedContracts && !hasPendingContractsWithToken }"
            >
                <div class="footer-column-lg d-flex align-items-center h-100 justify-content-center">
                    <span *ngIf="!selectedContract">{{ "pt.edp.edponline.contract.list.consumption.local.none" | translate }}</span>
                    <span *ngIf="selectedContract" (click)="selectContract(selectedContract)" class="cursor-pointer">
                        {{ "pt.edp.edponline.selected.place" | translate }}
                        <span class="font-weight-bold">{{ selectedContract.Nickname }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="edp-contract-third-party-modal-container"></div>

<ng-template #templateAddContract>
    <div class="col mb-2 mb-md-4 d-block">
        <div class="edp-card-contract card h-100 justify-content-center" (click)="addContract()">
            <div class="card-icon text-center">
                <span><i class="icon icon-edponline-Bop-074 disabled" aria-hidden="true"></i></span>
            </div>
            <div class="mt-2 origin text-center">
                <span>{{ "pt.edp.edponline.contract.list.add.third.party" | translate }}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #templateSyncWallet>
    <div class="col mb-2 mb-md-4 d-block">
        <div class="edp-card-contract card edp-card-sync-wallet h-100 justify-content-center" (click)="syncWallet()">
            <div class="mt-2 text-center">
                <span [innerHTML]="'pt.edp.edponline.contract.list.sync.wallet' | translate"></span>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #searchDefault>
    <div class="d-flex flex-row justify-content-between align-items-start contract-list-filter">
        <ng-container *ngIf="!!isSearching">
            <input type="text" class="w-100 search-input"
                placeholder="{{ 'pt.edp.edponline.contract.list.filter.search.consumption.place' | translate }}"
                [(ngModel)]="searchByText" (keyup)="onKeyPress($event)" />

            <button class="btn btn-search py-0" (click)="showSearchContract()">
                <span class="d-block pt-2">
                    {{ "pt.edp.edponline.contract.list.filter.close" | translate }}
                </span>
            </button>
        </ng-container>
        <ng-container *ngIf="!isSearching">
            <edp-contract-list-filter></edp-contract-list-filter>
            <button class="btn btn-search py-0" (click)="showSearchContract()">
                <i class="icon icon-edponline-Bop-055" aria-hidden="true"></i>
            </button>
        </ng-container>
    </div>
</ng-template>

